import { Box, CircularProgress, Typography } from '@mui/material';
import CouponsList from '../../components/Coupons/CouponsList';
import CouponsPagination from '../../components/CouponsPagination/CouponsPagination';

const CuponsTop = ({ coupons = [], totalPages = 0, loading, error }) => {
    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                <CircularProgress color="primary" />
            </Box>
        );
    }
    if (error) return <Typography color="error">{error}</Typography>;

    return (
        <CouponsList
            coupons={coupons}
            pagination={totalPages > 1 ? <CouponsPagination couponProp={coupons} totalPages={totalPages} /> : null}
        />
    );
};

export default CuponsTop;
